import tw from "src/utils/tw";

export default function BodyContent(props) {
  return (
    <div
      className={tw(
        "flex",
        "md:overflow-hidden",
        "flex-1",
        // "sm:block",
        "sm:flex-col",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
